export enum TokenResponseType {
    Success = "Success",
    Cancel = "Cancel",
    InteractionRequired = "InteractionRequired",
    TemporarilyUnavailable = "TemporarilyUnavailable",
    ShuttingDown = "ShuttingDown",
    ExtendedError = "ExtendedError",
    InsufficientPermissions = "InsufficientPermissions"
}
